// import hoja de estilo css
import "./GraficaData.css";

// import hooks
import { useContext } from "react";

// import context
import { DarkModeContext } from "../../context/DarkModeContext";

// import assets
import amexPNG from "../../assets/img/amex.png";
import argencardPNG from "../../assets/img/argencard.png";
import cabalPNG from "../../assets/img/cabal.png";
import dinersPNG from "../../assets/img/diners.png";
import masterPNG from "../../assets/img/mastercard.png";
import naranjaxPNG from "../../assets/img/naranjax.png";
import visaPNG from "../../assets/img/visa.png";
import amexBlancoPNG from "../../assets/img/amex-blanco.png";
import argencardBlancoPNG from "../../assets/img/argencard-blanco.png";
import cabalBlancoPNG from "../../assets/img/cabal-blanco.png";
import dinersBlancoPNG from "../../assets/img/diners-blanco.png";
import masterBlancoPNG from "../../assets/img/mastercard-blanco.png";
import naranjaxBlancoPNG from "../../assets/img/naranjax-blanco.png";
import visaBlancoPNG from "../../assets/img/visa-blanco.png";

// import helpers
import { formatearMonto } from "../../helpers/formatearAPeso";

const GraficaData = ({ datos }) => {
  // variable para extraer los array de los datos
  const { descuentosPorTarjeta = [] } = datos;
  const { darkMode } = useContext(DarkModeContext);

  const imagenes = darkMode
    ? {
        Visa: visaBlancoPNG,
        MasterCard: masterBlancoPNG,
        Argencard: argencardBlancoPNG,
        Amex: amexBlancoPNG,
        Diners: dinersBlancoPNG,
        Cabal: cabalBlancoPNG,
        Naranjax: naranjaxBlancoPNG,
      }
    : {
        Visa: visaPNG,
        MasterCard: masterPNG,
        Argencard: argencardPNG,
        Amex: amexPNG,
        Diners: dinersPNG,
        Cabal: cabalPNG,
        Naranjax: naranjaxPNG,
      };

  const tarjetasOrdenadas = [...descuentosPorTarjeta].sort(
    (a, b) => (b.totalConDescuento || 0) - (a.totalConDescuento || 0)
  );
  const totalFacturacion = tarjetasOrdenadas.reduce(
    (total, tarjeta) => total + (tarjeta.totalConDescuento || 0),
    0
  );
  const mayorValor = Math.max(
    ...tarjetasOrdenadas.map((tarjeta) => tarjeta.totalConDescuento || 0),
    0
  );

  return (
    <section
      translate="no"
      className="container grafica-tarjetas-section"
      style={{ "--tarjetas-count": tarjetasOrdenadas.length }}
    >
      <article
        className={
          darkMode
            ? " bg-grafica-dark grafica-tarjetas-card position-relative"
            : "bg-grafica grafica-tarjetas-card position-relative"
        }
      >
        <div className="grafica-tarjetas-header">
          <div>
            <h2>{"Facturaci\u00f3n por tarjeta"}</h2>
            <p>{"Distribuci\u00f3n de las ventas"}</p>
          </div>
        </div>

        <div className="grafica-tarjetas-list">
          {tarjetasOrdenadas.map((tarjeta, index) => {
            const valor = tarjeta.totalConDescuento || 0;
            const porcentajeTotal =
              totalFacturacion > 0 ? (valor / totalFacturacion) * 100 : 0;
            const porcentajeBarra =
              mayorValor > 0 ? (valor / mayorValor) * 100 : 0;
            const nombreTarjeta = tarjeta.tarjeta;
            const imagen = imagenes[nombreTarjeta];

            return (
              <article
                className="grafica-tarjetas-row"
                key={`${nombreTarjeta}-${index}`}
                title={`${nombreTarjeta}: ${formatearMonto(valor)} (${porcentajeTotal.toFixed(0)}%)`}
              >
                <div className="grafica-tarjetas-name">
                  {imagen ? (
                    <img src={imagen} alt={nombreTarjeta} />
                  ) : (
                    <span>{nombreTarjeta}</span>
                  )}
                </div>
                <div className="grafica-tarjetas-track" aria-hidden="true">
                  <span style={{ width: `${porcentajeBarra}%` }} />
                </div>
                <strong>{formatearMonto(valor)}</strong>
                <span className="grafica-tarjetas-percent">
                  {porcentajeTotal.toFixed(0)}%
                </span>
              </article>
            );
          })}
        </div>
      </article>
    </section>
  );
};

export default GraficaData;
